import {
  __experimentalInputControl as InputControl,
  __experimentalNumberControl as NumberControl,
  PanelBody,
  ToggleControl,
} from "@wordpress/components";

import { InspectorControls } from "@wordpress/block-editor";

import { __ } from "@wordpress/i18n";

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const {
    name,
    isRequired,
    label,
    id,
    accept,
    placeholder,
    placeholderClickText,
    maxFiles,
    maxFileSizeMB,
  } = attributes;

  return (
    <>
      <InspectorControls>
        <PanelBody title={__("Settings")}>
          <InputControl
            label={__("Label")}
            value={label}
            onChange={(v) => setAttributes({ label: v })}
          />
          <InputControl
            label={__("Name")}
            value={name}
            onChange={(v) => setAttributes({ name: v })}
          />
          <InputControl
            label={__("Id")}
            value={id}
            onChange={(v) => setAttributes({ id: v })}
          />
          <ToggleControl
            __nextHasNoMarginBottom
            label={__("Is required")}
            checked={isRequired}
            onChange={(v) => {
              setAttributes({ isRequired: v });
            }}
          />
        </PanelBody>
        <PanelBody title={__("Upload Settings", "brandy-blocks")}>
          <div className="components-base-control">
            <label className="components-base-control__label">
              {__("Accept", "brandy")}
            </label>
            <InputControl
              value={accept}
              onChange={(v) => setAttributes({ accept: v })}
            />
          </div>
          <NumberControl
            __next40pxDefaultSize
            label={__("Max files", "brandy-blocks")}
            help={__("Maximum number of files allowed (1 = single file).", "brandy-blocks")}
            min={1}
            step={1}
            value={maxFiles}
            onChange={(v) => {
              const parsed = Math.round(parseFloat(v));
              setAttributes({ maxFiles: Number.isFinite(parsed) && parsed >= 1 ? parsed : 1 });
            }}
          />
          <NumberControl
            __next40pxDefaultSize
            label={__("Max file size (MB)", "brandy-blocks")}
            help={__("Maximum size per file in megabytes. 0 = no limit.", "brandy-blocks")}
            min={0}
            step={1}
            value={maxFileSizeMB}
            onChange={(v) => {
              const parsed = Math.round(parseFloat(v));
              setAttributes({ maxFileSizeMB: Number.isFinite(parsed) && parsed >= 0 ? parsed : 0 });
            }}
          />
        </PanelBody>
        <PanelBody title={__("Placeholder", "brandy-blocks")}>
          <InputControl
            label={__("Placeholder text", "brandy-blocks")}
            help={__('Use {click} to insert the clickable link text', "brandy-blocks")}
            value={placeholder}
            onChange={(v) => setAttributes({ placeholder: v })}
          />
          <InputControl
            label={__("Click text", "brandy-blocks")}
            value={placeholderClickText}
            onChange={(v) => setAttributes({ placeholderClickText: v })}
          />
        </PanelBody>
      </InspectorControls>
    </>
  );
}
